module.exports = __webpack_public_path__ + "img/noauth.fcb28b8c.png";